module.exports = __webpack_public_path__ + "static/media/6b.e0175979.png";